import React from 'react';
import { Link } from 'react-router-dom';
import ZoomGallery from '../components/ZoomGallery';
import { responsiveImage, CARD_WIDTHS } from '../data/responsiveImage';
import { GOLD, GOLD_LT, CREAM, INK } from '../theme';
import { findImageByRole, galleryImages } from '../data/imageUrl';
import { whatsappUrl } from '../data/whatsapp';

export default function CollectionDetailView({ collection, others, imageUrl }) {
  const images = [findImageByRole(collection, 'main'), ...galleryImages(collection)].filter(Boolean);
  const pageUrl = `${window.location.origin}/collections/${collection.slug}`;

  return (
    <div style={{ fontFamily: "'Cormorant Garamond', serif", background: INK, color: '#efe4d2' }}>
      <section style={{ maxWidth: 1240, margin: '0 auto', padding: 'clamp(28px,5vh,48px) clamp(20px,4vw,60px) 0' }}>
        <Link to="/#collections" style={{ display: 'inline-block', fontSize: 13, letterSpacing: '.18em', textTransform: 'uppercase', color: 'rgba(239,228,210,.55)', textDecoration: 'none' }}>← All Collections</Link>
      </section>

      <section style={{ maxWidth: 1240, margin: '0 auto', padding: 'clamp(20px,3vh,32px) clamp(20px,4vw,60px) clamp(60px,9vh,100px)', display: 'flex', flexWrap: 'wrap', gap: 'clamp(32px,5vw,64px)' }}>

        {/* GALLERY */}
        <div style={{ flex: '1 1 420px', minWidth: 0, maxWidth: 560 }}>
          <ZoomGallery images={images} imageUrl={imageUrl} altBase={`${collection.name} — ${collection.tagline}`} />
        </div>

        {/* INFO */}
        <div style={{ flex: '1 1 320px', minWidth: 0, paddingTop: 4 }}>
          <div style={{ fontWeight: 600, fontSize: 14, letterSpacing: '.36em', textTransform: 'uppercase', color: GOLD, marginBottom: 14 }}>The Collection</div>
          <h1 style={{ fontFamily: "'Bodoni Moda', serif", fontWeight: 500, fontStyle: 'italic', fontSize: 'clamp(42px,5vw,64px)', lineHeight: 1, margin: '0 0 14px', color: CREAM }}>{collection.name}</h1>
          <span style={{ display: 'inline-block', fontSize: 13, letterSpacing: '.18em', textTransform: 'uppercase', color: '#b0293b', fontWeight: 600, marginBottom: 26 }}>{collection.tagline}</span>

          <p style={{ fontSize: 18, lineHeight: 1.75, color: 'rgba(239,228,210,.8)', maxWidth: 460, margin: '0 0 28px' }}>{collection.description}</p>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 34, paddingBottom: 34, borderBottom: '1px solid rgba(201,162,75,.2)' }}>
            {(collection.details || []).map((d, i) => (
              <div key={`${d}-${i}`} style={{ display: 'flex', alignItems: 'baseline', gap: 12, fontSize: 15, color: 'rgba(239,228,210,.75)' }}>
                <span style={{ color: GOLD_LT }}>—</span>{d}
              </div>
            ))}
          </div>

          <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap' }}>
            <Link to="/book-appointment" style={{ display: 'inline-block', fontWeight: 600, fontSize: 13, letterSpacing: '.2em', textTransform: 'uppercase', padding: '16px 38px', background: GOLD, color: INK, textDecoration: 'none' }}>Book an Appointment</Link>
            <a href={whatsappUrl(collection.name, pageUrl)} target="_blank" rel="noopener noreferrer" style={{ display: 'inline-block', fontWeight: 600, fontSize: 13, letterSpacing: '.2em', textTransform: 'uppercase', padding: '16px 38px', background: 'none', border: `1px solid ${GOLD_LT}`, color: GOLD_LT, textDecoration: 'none' }}>Talk to Fashion Consultant</a>
          </div>
        </div>
      </section>

      {/* MORE COLLECTIONS */}
      {others.length > 0 && (
        <section style={{ padding: 'clamp(50px,8vh,80px) 0 clamp(70px,10vh,110px)', borderTop: '1px solid rgba(201,162,75,.2)' }}>
          <div style={{ padding: '0 clamp(20px,4vw,60px)', marginBottom: 36 }}>
            <h2 style={{ fontFamily: "'Bodoni Moda', serif", fontWeight: 500, fontStyle: 'italic', fontSize: 'clamp(28px,3.4vw,40px)', margin: 0, color: CREAM }}>More from the atelier</h2>
          </div>
          <div className="ij-car" style={{ display: 'flex', gap: 24, overflowX: 'auto', padding: '0 clamp(20px,4vw,60px)' }}>
            {others.map((c) => {
              const thumb = findImageByRole(c, 'thumb');
              return (
                <Link key={c.slug} to={`/collections/${c.slug}`} style={{ flex: '0 0 auto', width: 220, textDecoration: 'none', color: 'inherit' }}>
                  <div style={{ position: 'relative', width: '100%', aspectRatio: '3 / 4', background: 'repeating-linear-gradient(135deg,#2a2016,#2a2016 14px,#231a11 14px,#231a11 28px)', border: '1px solid rgba(201,162,75,.4)', overflow: 'hidden' }}>
                    {/* alt duplicated the name printed directly beneath it. */}
                    {thumb && <img {...responsiveImage(imageUrl(thumb), CARD_WIDTHS, '220px')} alt="" loading="lazy" decoding="async" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'top' }} />}
                  </div>
                  <div style={{ marginTop: 12, fontFamily: "'Bodoni Moda', serif", fontSize: 20, color: CREAM }}>{c.name}</div>
                </Link>
              );
            })}
          </div>
        </section>
      )}
    </div>
  );
}
